<template>
  <FormGroup>
    <FormField label="Monthly rent" :error="form.fieldErrors('rent')">
      <Input v-model="form.fields.rent" type="number" min="0">
        <template #prefix>$</template>
      </Input>
    </FormField>

    <FormField label="Security deposit" :error="form.fieldErrors('securityDeposit')">
      <Select v-model="form.fields.securityDeposit">
        <option v-for="option in incomeOptions" :key="option" :value="option">{{ option }}</option>
      </Select>
    </FormField>
  </FormGroup>
</template>

<script setup lang="ts">
import { minValue, numeric, required } from '@vuelidate/validators';
import { watch } from 'vue';

import { FormField, FormGroup, Input, Select, useForm } from '@tallo/design-system';
import { LeaseConditionIncome, PropertyLeaseConditionsDto } from '@tallo/property';

import { SaveLeaseConditionsDto } from '../../dtos/save-lease-condition.dto.interface';
import { usePropertyStore } from '../../stores/property.store';

const incomeOptions = Object.values(LeaseConditionIncome);
const propertyStore = usePropertyStore();
const form = useForm<Pick<SaveLeaseConditionsDto, 'rent' | 'securityDeposit'>>(
  {
    rent: null,
    securityDeposit: null,
  },
  {
    rent: { required, numeric, minValueValue: minValue(1) },
  },
);

async function save() {
  return form.submit(async (fields) => await propertyStore.saveLeaseConditions(fields));
}

function populateForm(leaseConditions: PropertyLeaseConditionsDto) {
  Object.assign(form.fields, {
    rent: leaseConditions?.rent ?? null,
    securityDeposit: leaseConditions?.securityDeposit ?? LeaseConditionIncome.X1_RENT,
  });
}

watch(() => propertyStore.property?.leaseConditions!, populateForm, { immediate: true });

defineExpose({ save, form });
</script>
